var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonthlyPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.682,
    height: 18.062,
    viewBox: "0 0 17.682 18.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22375",
    "data-name": "Group 22375",
    transform: "translate(-3.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29056",
    "data-name": "Path 29056",
    d: "M21.441,39.128a.231.231,0,0,0-.228-.228H19.328a.231.231,0,0,0-.228.228v1.713a.231.231,0,0,0,.228.228h1.884a.231.231,0,0,0,.228-.228Z",
    transform: "translate(-12.631 -29.472)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29057",
    "data-name": "Path 29057",
    d: "M56.128,38.9a.231.231,0,0,0-.228.228v1.713a.231.231,0,0,0,.228.228h1.884a.231.231,0,0,0,.228-.228V39.128a.231.231,0,0,0-.228-.228Z",
    transform: "translate(-42.427 -29.472)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29058",
    "data-name": "Path 29058",
    d: "M39.613,38.9H37.728a.231.231,0,0,0-.228.228v1.713a.231.231,0,0,0,.228.228h1.884a.231.231,0,0,0,.228-.228V39.128A.231.231,0,0,0,39.613,38.9Z",
    transform: "translate(-27.529 -29.472)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29059",
    "data-name": "Path 29059",
    d: "M21.113,56.2H19.228a.231.231,0,0,0-.228.228v1.713a.231.231,0,0,0,.228.228h1.884a.231.231,0,0,0,.228-.228V56.428A.219.219,0,0,0,21.113,56.2Z",
    transform: "translate(-12.55 -43.479)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29060",
    "data-name": "Path 29060",
    d: "M39.613,56.2H37.728a.231.231,0,0,0-.228.228v1.713a.231.231,0,0,0,.228.228h1.884a.231.231,0,0,0,.228-.228V56.428A.246.246,0,0,0,39.613,56.2Z",
    transform: "translate(-27.529 -43.479)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29061",
    "data-name": "Path 29061",
    d: "M12.046,16.318H5.575a.621.621,0,0,1-.628-.628V8.02H17.356v3.407a4.986,4.986,0,0,1,1.427.247V6.135a1.95,1.95,0,0,0-1.941-1.941H15.4V3.109a.6.6,0,0,0-.609-.609H13.644a.6.6,0,0,0-.609.609V4.194H9.248V3.109A.6.6,0,0,0,8.639,2.5H7.478a.613.613,0,0,0-.609.609V4.194H5.422A1.946,1.946,0,0,0,3.5,6.135v9.535a2.079,2.079,0,0,0,2.075,2.075h6.6a4.773,4.773,0,0,1-.133-1.18Z",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29062",
    "data-name": "Path 29062",
    d: "M58.4,55.4a4,4,0,1,0,4,4A4,4,0,0,0,58.4,55.4ZM58.226,59h.381a1.336,1.336,0,0,1,1.332,1.466,1.353,1.353,0,0,1-1.1,1.161v.552a.123.123,0,0,1-.114.114h-.609A.123.123,0,0,1,58,62.176v-.533a1.335,1.335,0,0,1-1.1-1.2.123.123,0,0,1,.114-.114h.609a.129.129,0,0,1,.114.076.482.482,0,0,0,.495.438h.343a.533.533,0,0,0,.533-.419.5.5,0,0,0-.514-.59h-.324a1.383,1.383,0,0,1-1.389-1.2,1.33,1.33,0,0,1,1.1-1.446v-.533a.123.123,0,0,1,.114-.114H58.7a.123.123,0,0,1,.114.114v.533a1.335,1.335,0,0,1,1.1,1.2.123.123,0,0,1-.114.114H59.2a.129.129,0,0,1-.114-.076.514.514,0,0,0-.514-.438h-.343a.506.506,0,1,0,0,1.009Z",
    transform: "translate(-41.212 -42.832)",
    fill: "#170A33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyPayment);
export default __webpack_public_path__ + "static/media/MonthlyPayment.b97d01cd3e732ebc7466cdec360bb46c.svg";
export { ForwardRef as ReactComponent };